"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runsOnDevice = exports.appModes = exports.deviceModes = exports.pages = void 0;

var _includes = _interopRequireDefault(require("lodash/includes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @classdesc
 * Every page should have an unique ID.
 *
 * @namespace skybase-core.constants.pages
 *
 * @type {Object}
 * @property {Object} DAQ - 'DAQ_PAGE'
 * @property {Object} MAINTENANCE - MAINTENANCE
 * @property {Object} PARAMETER_TREE - PARAMETER_TREE
 * @property {Object} DEVICE - DEVICE
 * @property {Object} EXPORT_IMPORT - EXPORT_IMPORT
 *
 */
var pages = {
  DAQ: {
    id: 'DAQ_PAGE',
    breadcrumb: 'Data Acquisition Page',
    url: 'daq'
  },
  MAINTENANCE: {
    id: 'MAINTENANCE',
    breadcrumb: 'Maintenance',
    url: 'maintenance'
  },
  LICENSING: {
    id: 'LICENSING',
    breadcrumb: 'Licensing',
    url: 'maintenance/licensing'
  },
  MESSAGE_HISTORY: {
    id: 'MESSAGE_HISTORY',
    breadcrumb: 'Message History',
    url: 'maintenance/message-history'
  },
  ALARMS_AND_NOTIFICATIONS: {
    id: 'ALARMS_AND_NOTIFICATIONS',
    breadcrumb: 'Alarms & Notifications',
    url: 'maintenance/alarms_and_notifications'
  },
  ABOUT: {
    id: 'ABOUT',
    breadcrumb: 'About',
    url: 'maintenance/about'
  },
  PARAMETER_TREE: {
    id: 'PARAMETER_TREE',
    breadcrumb: 'Parameter Tree',
    url: 'parameter_tree'
  },
  DEVICE: {
    id: 'DEVICE',
    breadcrumb: 'Device',
    url: 'device'
  },
  EXPORT_IMPORT: {
    id: 'EXPORT_IMPORT',
    breadcrumb: 'Export/Import',
    url: 'export_import'
  },
  GENERAL_DEVICE_SETTINGS: {
    id: 'GENERAL_DEVICE_SETTINGS',
    breadcrumb: 'General Device Settings',
    url: 'device-settings'
  },
  NETWORK_SETTINGS: {
    id: 'NETWORK_SETTINGS',
    breadcrumb: 'Network Setup',
    url: 'device-settings/network'
  },
  DATE_TIME_SETTINGS: {
    id: 'DATE_TIME_SETTINGS',
    breadcrumb: 'Date/Time',
    url: 'device-settings/date-time'
  }
};
/**
 * @classdesc
 *
 * @namespace skybase-core.constants.deviceModes
 *
 * @type {Object}
 * @property {String} NORMAL_MODE - 'NORMAL_MODE'
 * @property {String} UPDATE_MODE - 'UPDATE_MODE'
 * @property {String} OFF_MODE - 'OFF_MODE'
 *
 */

exports.pages = pages;
var deviceModes = {
  NORMAL_MODE: 'NORMAL_MODE',
  UPDATE_MODE: 'UPDATE_MODE',
  OFF: 'OFF_MODE' // when device is not responding, rebooting, or is turned off.

};
/**
 * @desc
 * Enums for application modes.
 *
 * @type {{DEVELOPMENT: string, PRODUCTION: string}}
 */

exports.deviceModes = deviceModes;
var appModes = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production'
};
/**
 * @desc
 * Defines if UI application runs on device.  Returns false if running under nodejs.
 *
 * @type {Boolean}
 */

exports.appModes = appModes;
var runsOnDevice = (0, _includes.default)(['localhost', '127.0.0.1'], typeof location !== 'undefined' && location ? location.host : 'nodejs');
exports.runsOnDevice = runsOnDevice;
//# sourceMappingURL=constants.js.map